import React from "react";

import Divider from "./Divider";
import EditCoachingPlanHead, { ViewState } from "./EditCoachingPlanHead";
import WeeklyPlanEditor from "./WeeklyPlanEditor";
import PersonalRoutineEditor from "./PersonalRoutineEditor";

const CurrentWeekView = ({
    activityStats = null,
    coachingPlan = null,
    coachingPlanTrackOptions = null,
    constPlan = null,
    constRoutine = null,
    name = null,
    personalRoutine = null,
    restrictCoachingPlanEnd = false,
    routineScoreData = null,
    selectedCoachingPlanTrack = null,
    selectedWeek = null,
    vetKitVersion = null,
    weekOptions = null,
    // Callbacks
    onAddWeeks = null,
    onChangeWeek = null,
    onCompleteWeek = null,
    onConfirmAddWeeks = null,
    onEndPlan = null,
    onSaveChanges = null,
    onSetTemplate = null,
    onTogglePersonalRoutine = null,
    setBonusActivityCallback = null,
    setBonusDurationCallback = null,
    setBonusOptionsCallback = null,
    setPersonalRoutineActivityCallback = null,
    setPersonalRoutineDurationCallback = null,
    setPersonalRoutineOptionsCallback = null
}) => {
    return (
        <div className="w-[100%] p-10 flex-col justify-center items-center gap-y-6 inline-flex">
            <div id="head" className="w-full justify-center items-center gap-x-3 inline-flex">
                <EditCoachingPlanHead
                    coachingPlan={coachingPlan}
                    coachingPlanTrackOptions={coachingPlanTrackOptions}
                    restrictCoachingPlanEnd={restrictCoachingPlanEnd}
                    selectedCoachingPlanTrack={selectedCoachingPlanTrack}
                    selectedWeek={selectedWeek}
                    state={ViewState.Active}
                    weekOptions={weekOptions}
                    // Callbacks
                    onAddWeeks={onAddWeeks}
                    onCompleteWeek={onCompleteWeek}
                    onConfirmAddWeeks={onConfirmAddWeeks}
                    onEndPlan={onEndPlan}
                    onSaveChanges={onSaveChanges}
                    setCoachingPlanTrackCallback={onSetTemplate}
                    setSelectedWeekCallback={onChangeWeek}
                />
            </div>
            <div id="divider" className="w-full justify-center items-center inline-flex">
                <Divider label={"Assignments"}/>
            </div>
            <div id="divider" className="w-full justify-center items-center gap-3 inline-flex rounded-[10px] shadow border border-gray-200">
                <PersonalRoutineEditor
                    onTogglePersonalRoutine={onTogglePersonalRoutine}
                    activityStats={activityStats}
                    constRoutine={constRoutine}
                    firstName={name}
                    personalRoutine={personalRoutine}
                    routineBadgeData={routineScoreData}
                    selectedWeek={selectedWeek}
                    state={ViewState.Active}
                    vetKitVersion={vetKitVersion}
                    // Callbacks
                    setActivityCallback={setPersonalRoutineActivityCallback}
                    setDurationCallback={setPersonalRoutineDurationCallback}
                    setOptionsCallback={setPersonalRoutineOptionsCallback}
                />
            </div>
            <div id="divider" className="w-full  justify-center items-center gap-3 inline-flex  rounded-[10px] shadow border border-gray-200 ">
                <WeeklyPlanEditor
                    activityStats={activityStats}
                    coachingPlan={coachingPlan}
                    constPlan={constPlan}
                    selectedWeek={selectedWeek}
                    state={ViewState.Active}
                    vetKitVersion={vetKitVersion}
                    // Callbacks
                    setActivityCallback={setBonusActivityCallback}
                    setDurationCallback={setBonusDurationCallback}
                    setOptionCallback={setBonusOptionsCallback}
                />
            </div>
        </div>
    );
};

export default CurrentWeekView;
